import React, { createContext, useContext, useMemo, useState } from 'react';
import { ApiManager } from '../api/api';
import useMousePosition from '../components/Widget/common/DeviationWidget/hooks/useMousePosition';
const defaultConfig = {
    APP_ID: '',
    TENANT_ID: '',
    API_BASE_URL: '',
    API_BASE_URL_INVENTORY: '',
    API_BASE_URL_FIELDS: '',
    GOOGLE_MAP_API_KEY: '',
    GOOGLE_MAP_VERSION: '',
    ALARMS_VIEW_MORE_LINK: '',
    MACHINE_STATUS_VIEW_MORE_LINK: '',
    MAP_VIEW_MORE_LINK: '',
    RESOURCES_BASE_URL: '',
    TASKS_VIEW_MORE_LINK: '',
    FEED_URL: '',
};
const DashboardConfigContext = createContext({
    config: defaultConfig,
    tooltip: { openTooltip: () => undefined, closeTooltip: () => undefined },
    api: ApiManager({
        HTTPBaseURL: defaultConfig.API_BASE_URL,
        HTTPInventory: defaultConfig.API_BASE_URL_INVENTORY,
        HTTPFields: defaultConfig.API_BASE_URL_FIELDS,
        googleMapApiKey: defaultConfig.GOOGLE_MAP_API_KEY,
    }),
});
const Tooltip = ({ tooltip }) => {
    const position = useMousePosition();
    const left = tooltip.open ? position.x : -9999;
    const top = tooltip.open ? position.y : -9999;
    return (React.createElement("div", { style: {
            position: 'fixed',
            left: left + 5,
            top: top + 5,
            zIndex: 9999,
            ...tooltip.style,
        } }, tooltip.content));
};
export const DashboardConfigProvider = ({ config, children }) => {
    const emptyTooltip = {
        open: false,
        content: null,
    };
    const [tooltip, setTooltip] = useState(emptyTooltip);
    const openTooltip = (content) => {
        setTooltip({
            open: true,
            content,
        });
    };
    const closeTooltip = () => {
        setTooltip(emptyTooltip);
    };
    const contextValue = useMemo(() => ({
        config,
        tooltip: { openTooltip, closeTooltip },
        api: ApiManager({
            HTTPBaseURL: config.API_BASE_URL,
            HTTPInventory: config.API_BASE_URL_INVENTORY,
            HTTPFields: config.API_BASE_URL_FIELDS,
            googleMapApiKey: config.GOOGLE_MAP_API_KEY,
        }),
    }), [config]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { tooltip: tooltip }),
        React.createElement(DashboardConfigContext.Provider, { value: contextValue }, children)));
};
export const useDashboardContext = () => useContext(DashboardConfigContext);
export const useDashboardConfig = () => useContext(DashboardConfigContext).config;
export const useDashboardAPI = () => useContext(DashboardConfigContext).api;
export const useDashboardTooltip = () => useContext(DashboardConfigContext).tooltip;
//# sourceMappingURL=useDashboardContext.js.map